import { FallbackProps, useErrorBoundary } from 'react-error-boundary'
import { ErrorMessage } from './ErrorMessage'

export function ErrorBoundaryComponent(props: FallbackProps) {
  const { resetBoundary } = useErrorBoundary()
  const { error } = props
  if (process.env.NODE_ENV === 'development') {
    console.error(error)
  }
  return <ErrorMessage clearError={resetBoundary} />
}
